import React from 'react';
import { Link } from 'react-router-dom';
import './ServicePage.css';
import parcelImage from '../../assets/services/parcel.jpg';
import { FaBox, FaClock, FaShieldAlt, FaMapMarkedAlt } from 'react-icons/fa';

function TransportColis() {
  const features = [
    {
      icon: <FaBox />,
      title: "Tous Types de Colis",
      description: "Transport sécurisé pour colis de toutes tailles et types"
    },
    {
      icon: <FaClock />,
      title: "Livraison Express",
      description: "Service rapide avec possibilité de livraison le jour même"
    },
    {
      icon: <FaShieldAlt />,
      title: "Sécurité Garantie",
      description: "Suivi en temps réel et manipulation soigneuse de vos colis"
    },
    {
      icon: <FaMapMarkedAlt />,
      title: "Large Couverture",
      description: "Livraison dans toute la région vaudoise et ses environs"
    }
  ];

  return (
    <main className="service-page">
      {/* Hero Section */}
      <section className="service-hero" style={{ backgroundImage: `url(${parcelImage})` }}>
        <div className="service-hero-overlay"></div>
        <div className="service-hero-content">
          <h1>Transport de Colis</h1>
          <p>Livraison rapide et sécurisée de vos colis</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="service-content">
        <div className="service-container">
          {/* Description */}
          <div className="service-description">
            <h2>Service de Livraison Professionnel</h2>
            <p>
              Notre service de transport de colis offre une solution fiable et efficace 
              pour vos besoins de livraison. Que ce soit pour des documents urgents, 
              des colis fragiles ou des livraisons volumineuses, nous garantissons un 
              service professionnel et ponctuel.
            </p>
            <p>
              Chaque colis est traité avec le plus grand soin, et vous pouvez suivre 
              sa progression en temps réel. Notre équipe expérimentée s'assure que vos 
              biens arrivent à destination en toute sécurité et dans les délais convenus.
            </p>
          </div>

          {/* Features Grid */}
          <div className="service-features">
            {features.map((feature, index) => (
              <div key={index} className="service-feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>

          {/* Call to Action */}
          <div className="service-cta">
            <h2>Envoyez Vos Colis</h2>
            <p>
              Contactez-nous pour organiser votre livraison rapidement et en toute sécurité.
            </p>
            <div className="cta-buttons">
              <a href="tel:+41797774444" className="cta-button secondary">
                +41 79 777 44 44
              </a>
              <Link to="/quote" className="cta-button primary">
                Demander un Devis
              </Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default TransportColis; 